import { Box } from '@hivebrite/design-system/Box';

import SharedContentThumbnail from 'hb-react/frontoffice/components/ShareContentModal/components/SharedContentThumbnail';

const AssociatedRecordContent = ({ fromRecord }) => {
  if (!fromRecord) return null;

  switch (fromRecord.type) {
    case 'MediaCenter::Folder':
    case 'MediaCenter::File':
    case 'Article':
      return (
        <Box mt={2} display="block">
          <SharedContentThumbnail fromRecord={fromRecord} />
        </Box>
      );
    default:
      return null;
  }
};

export default AssociatedRecordContent;
